import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Microphone icon
 *
 * @category Product
 */
const Microphone = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M24.605 13.213c-.986.262 0 2.15-1.057 2.269-.309.035-.831 0-1.354.011-1.14-.07-1.781.202-1.876-.296-.024-1.912 0-5.19 0-6.888.107-1.674-.368-3.456-1.805-4.489-2.292-1.805-5.997-.463-6.638 2.387-.451 2.755-.06 6.235-.202 8.99-.071.534-1.27.213-1.876.296-1.591 0-1.936.25-1.924-1.437-.024-.474-.356-1.009-.831-.724-.558.534-.261 1.686-.333 2.423-.202 4.488 3.147 8.823 7.54 9.559.333.071.82.107.998.392.404.51-.178 2.862.487 3.23.677.273.903-.356.855-1.306.083-1.057-.308-2.055.725-2.245 1.983-.309 3.954-1.27 5.403-2.838 2.268-2.292 2.85-5.724 2.494-8.8-.072-.332-.232-.534-.458-.557zM12.955 6.98c.321-2.553 4.014-3.681 5.463-1.342 1.021 1.52.63 3.848.713 5.961-.167 2.233.57 4.715-.891 6.58-1.793 2.16-5.284.617-5.332-2.079-.107-2.672-.143-6.187.012-8.93zm8.657 15.046c-4.334 4.322-12.836 1.722-13.608-4.263-.036-.369.023-.654.225-.832.523-.392 2.078-.308 2.91-.107.51.19.712.725.973 1.2 1.698 3.42 6.77 2.933 8.052-.594.51-.926 1.674-.736 2.612-.748 2.933-.083-.119 4.37-1.01 5.201l-.142.143z"
        />
      </svg>
    );
  }
);

Microphone.displayName = 'Microphone';

export { Microphone };
